import { View } from 'backbone.marionette';
import copy from 'copy-to-clipboard';
import Preloader from '../../../utils/Preloader';

/**
 * @desc Core League Congratulation View Class
 */
export default class CoreLeagueCongratulationView extends View {
	get template() {
		throw new Error("Need set template for child CoreLeagueCongratulationView class");
	}

	ui() {
		return {
			'copy_league_code': '.js-copy-league-code',
			'league_code':      '.js-league-code',
			'copied_code':      '.js-copied-code'
		};
	}

	events() {
		return {
			'click @ui.copy_league_code': 'copyCode'
		};
	}

	regions() {
		return {
			page_header: '.page-header'
		};
	}

	/**
	 *    Initialize view data
	 */
	async initialize() {
		this.league_id     = this.getOption( 'league_id' );

		Preloader.show();
		this.checkIsHiddenHeader();
		await this.fetchData();
		this.updateView();
		Preloader.hide();

	}

	/**
	 *
	 * @returns {*|Promise.<Object>}
	 */
	fetchData() {
		return this.model.setShowUrl().fetch( {
			data: {
				id: this.league_id
			}
		} );
	}

	updateView() {
		this.render();
	}

	checkIsHiddenHeader() {
		let show_header = this.getOption( 'show_header' );
		this.model.set( { show_header } );
		return this;
	}

	copyCode() {
		let code = this.getUI( 'league_code' ).val();
		copy( code );

		this.getUI( 'copied_code' ).removeClass( 'hidden' );
	}

}